<template>
  <div class="border rounded border-grayNeutralLight p-2 h-full overflow-auto">
    <div v-if="activity.length > 0" v-for="item in activity" :key="item.id" class="flex gap-1 mb-[12px]">
      <img :src="item?.user?.user_settings?.company_logo" :alt="item?.user?.name" class="rounded-full w-4 h-4" />
      <div>
        <p class="font-bold mb-[4px]">
          {{ item?.user?.name }} <span class="font-normal text-gray">{{ item.formatted_message }}</span>
        </p>
        <p class="text-gray text-12px mb-[4px]">{{ item.comment }}</p>
        <p class="text-gray text-12px mb-0">{{ item?.created_at | formatDate }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activity: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      comment: '',
    }
  },
  methods: {
    handleKeyPress(event) {
      if (event.key === 'Enter') {
        this.submitComment()
      }
    },
    submitComment() {
      if (this.comment.trim()) {
        console.log('Submitting comment:', this.comment)
        this.comment = ''
      }
    },
  },
}
</script>
